import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientService } from '@frontend/util-client-auth';
import { ScoButtonModule } from '@schueco/schueco-ui-components';

@Component({
  standalone: true,
  imports: [ScoButtonModule, RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private clientService = inject(ClientService);

  constructor() {
    this.clientService.changeStyles();
    this.clientService.changeTrustCommander();
  }
}
